<div class="payment-container">
  <div class="main-content">
    <div class="cbdc-header">
      <img src="assets/rupee1.png" alt="rupee">
      <h2>CBDC Payment</h2>
    </div>

    <div class="waiting-section">
      <div class="waiting-title">
        <img src="assets/Group.png" alt="icon">
        <h3>Waiting For Payment Approval</h3>
      </div>
      <p class="instruction-text">
        Open your CBDC wallet and approve the payment<br>
        request to complete the transaction.
      </p>
    </div>

    <div class="payment-options">
      <div class="phone-section">
        <img class="image" src="assets/Frame 1317.png" alt="screen">
      </div>

      <img class="Or" src="assets/Group 1470.png" alt="or">

      <div class="qr-section" (click)="toggleQr()">
        <ng-container *ngIf="!showQr">
          <img class="QR" src="assets/qrcode 1.png" alt="placeholder">
        </ng-container>
        <ng-container *ngIf="showQr">
          <img class="QR" [src]="safeQrSrc" alt="QR code">
        </ng-container>
        <div class="scan-me-text">Scan Me</div>
      </div>
    </div>
  </div>

  <div class="payment-sidebar">
    <div class="sidebar-header">
      <h3>Payment Request<br>Details</h3>
      <div class="dashed-line"></div>
    </div>

    <div class="payment-details">
      <div class="detail-row">
        <span class="label">Date</span>
        <span class="value">{{ date }}</span>
      </div>
      <div class="line"></div>

   <ng-container *ngIf="units">
      <div class="detail-row">
        <span class="label">No. of Units</span>
        <span class="value">{{ units }}</span>
      </div>
      <div class="line"></div>
    </ng-container>

      <div class="detail-row">
        <span class="label">Amount</span>
        <span class="value">₹ {{ amount | number:'1.2-2' }}</span>
      </div>
      <div class="dashed-line"></div>
    </div>

    <div class="timer-section">
      <div class="timer-circle" [ngStyle]="progressStyle">
        <div class="timer-display">
          <span class="time">{{ timeString }}</span>
          <span class="min-label">Min</span>
        </div>
      </div>
      <div class="timer-label">
        <div>Time Left</div>
        <div>to Pay</div>
      </div>
    </div>

    <button class="cancel-btn" (click)="cancel()">Cancel</button>
  </div>
</div>
